import { intl } from '@beelday/common'
import RecordingTrainerPopup from './recording-trainer-popup'
import { useOptionalRecordingState } from './recording-context'

/** Nothing where recording does not apply (`RecordingStateScope`). */
const RecordingResumePrompt = (): JSX.Element | null => {
	const recordingState = useOptionalRecordingState()

	if (!recordingState?.pendingResumePrompt) return null

	return (
		<RecordingTrainerPopup
			text={<intl.Translate>recording.resume_prompt.text</intl.Translate>}
			onAccept={recordingState.confirmResume}
			onClose={recordingState.dismissResumePrompt}
		/>
	)
}

export default RecordingResumePrompt
